import { IconDeviceGamepad2 } from '@tabler/icons-react';

import ProgressBar from '@/components/ProgressBar';
import TagCapsule from '@/components/TagCapsule';
import { LessonStatusConfig } from '@/constants/constant';
import { ELessonStatus } from '@/enum';
import { useDateFormatter } from '@/hooks/useDateFormatter';
import { useFormatText } from '@/hooks/useFormatText';

interface ILessonBreakdownCardProps {
  name: string;
  assignedDate: number | string;
  dueDate: number | string;
  progress: number;
  status: ELessonStatus;
  onClick?: () => void;
}

const LessonBreakdownCard = ({
  name,
  assignedDate,
  dueDate,
  progress,
  status,
  onClick,
}: ILessonBreakdownCardProps) => {
  const { formatText } = useFormatText();
  const { formatDate } = useDateFormatter();
  const config = status ? LessonStatusConfig[status] : null;

  return (
    <div
      className="bg-white rounded-2xl p-5 border border-neutral-light-200 flex flex-col gap-4 cursor-pointer hover:bg-brand-light-50 transition-shadow"
      onClick={onClick}
    >
      <div className="flex items-center gap-2">
        <div className="bg-orange-500 p-2 rounded-lg">
          <IconDeviceGamepad2 size={16} color="white" />
        </div>
        <h3 className="text-lg font-semibold text-neutral-primary wrap-anywhere">
          {name}
        </h3>
      </div>

      {config && (
        <div className="flex justify-between items-center">
          <span className="text-neutral-secondary">
            {formatText('lessons.lesson-status')}
          </span>
          <span className="font-semibold text-neutral-primary">
            <TagCapsule
              value={formatText(config.label)}
              className={config.className}
            />
          </span>
        </div>
      )}

      <div className="flex justify-between items-center">
        <span className="text-neutral-secondary">
          {formatText('lessons.assigned-date')}
        </span>
        <span className="font-semibold text-neutral-primary">
          {formatDate(assignedDate)}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-neutral-secondary">
          {formatText('lessons.due-date')}
        </span>
        <span className="font-semibold text-neutral-primary">
          {formatDate(dueDate)}
        </span>
      </div>

      <div className="flex flex-col gap-1.5">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-neutral-primary">
            {formatText('lessons.average-progress')}
          </span>
          <span className="font-bold text-neutral-primary">{progress}%</span>
        </div>
        <ProgressBar
          value={progress}
          showPercentage={false}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default LessonBreakdownCard;
